export default __webpack_public_path__ + "static/media/Logo.2e31deec.png";